import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Blogs() {
  const API_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/blogs`;

  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");

  // ✅ Strip HTML tags
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // 🔍 Fetch blogs (with debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      fetch(`${API_BASE}?search=${search}`)
        .then((res) => res.json())
        .then((data) => setBlogs(data.data || []));
    }, 400);

    return () => clearTimeout(delay);
  }, [search]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-100 flex justify-center">
      <div className="w-full max-w-6xl px-6 py-12">

        {/* 🔥 HERO */}
        <div className="mb-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">

          <div>
            <div className="h-1 w-24 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full mb-4"></div>

            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
              Insights for Engineers 🚀
            </h1>

            <p className="text-gray-600 text-lg mt-2 max-w-xl">
              Real interview experiences, salary breakdowns, and strategies to crack top tech companies.
            </p>
          </div>

          {/* ➕ WRITE BUTTON */}
          <Link to="/admin/blogs">
            <button className="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium shadow-lg hover:shadow-xl hover:scale-[1.03] transition-all">
              ✍️ Write Blog
            </button>
          </Link>
        </div>

        {/* 🔍 SEARCH */}
        <div className="mb-10">
          <input
            type="text"
            placeholder="Search blogs (Amazon, Google, salary...)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full p-4 rounded-2xl border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700 placeholder-gray-400 text-lg"
          />
        </div>

        {/* 🔥 BLOG LIST */}
        <div className="space-y-8">
          {blogs.map((blog) => (
            <Link key={blog._id} to={`/blogs/${blog.slug}`}>
              
              <div className="group bg-white p-6 rounded-3xl border border-gray-200 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 cursor-pointer">

                {/* TOP */}
                <div className="flex items-center gap-4 mb-4">

                  {/* Avatar */}
                  <div className="w-11 h-11 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white flex items-center justify-center font-semibold text-lg shadow">
                    {blog.author?.[0] || "A"}
                  </div>

                  {/* Author */}
                  <div>
                    <div className="text-gray-800 font-medium">
                      {blog.author || "Anonymous"}
                    </div>
                    <div className="text-xs text-gray-400">
                      {new Date(blog.createdAt).toDateString()}
                    </div>
                  </div>

                </div>

                {/* TITLE */}
                <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 group-hover:text-blue-600 transition leading-snug">
                  {blog.title}
                </h2>

                {/* PREVIEW (HTML FIXED) */}
                <p className="text-gray-600 mt-3 text-[15px] leading-relaxed line-clamp-2">
                  {stripHtml(blog.excerpt).slice(0, 140)}...
                </p>

                {/* FOOTER */}
                <div className="flex justify-between items-center mt-5">

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2">
                    {blog.tags?.map((tag, i) => (
                      <span
                        key={i}
                        className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full hover:bg-gray-200 transition"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>

                  {/* CTA */}
                  <div className="text-sm font-medium text-blue-600 opacity-0 group-hover:opacity-100 transition">
                    Read Article →
                  </div>

                </div>

              </div>

            </Link>
          ))}
        </div>

        {/* EMPTY STATE */}
        {blogs.length === 0 && (
          <div className="text-center text-gray-500 mt-20">
            No blogs found 😢
          </div>
        )}

      </div>
    </div>
  );
}